// src/components/search/HeaderSearch.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IoIosArrowBack } from 'react-icons/io';
import { AiOutlineSearch, AiOutlineQrcode } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import { base_url } from '../utils/config';

const HeaderSearch = () => {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState('');
  const { userInfo } = useSelector((state) => state.auth);

  const trackSearch = async (term) => {
    if (!userInfo || !term) return;
    try {
      await fetch(
        `${base_url}/api/search-activity/${userInfo.id}/search`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ searchTerm: term })
        }
      );
    } catch (err) {
      console.error('Error tracking search:', err);
    }
  };

  const doSearch = (raw) => {
    const q = raw.trim();
    if (!q) return;
    trackSearch(q);
    navigate(`/shops?search=${encodeURIComponent(q)}`);
  };

  return (
    <header className="fixed top-0 left-0 w-full h-14 bg-white flex items-center px-4 shadow-md z-50">
      <button
        onClick={() => navigate(-1)}
        className="p-2 flex items-center justify-center"
        aria-label="Go back"
      >
        <IoIosArrowBack size={24} className="text-gray-700" />
      </button>

      <div className="flex-1 mx-2">
        <div className="w-full h-10 flex items-center bg-gray-100 rounded-full px-4">
          <AiOutlineSearch className="text-gray-500 mr-2" size={20} />
          <input
            type="text"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && doSearch(searchValue)}
            placeholder="Search products, SKU codes, collections, etc."
            className="bg-transparent flex-1 outline-none text-sm text-gray-700"
          />
        </div>
      </div>

      <button
        onClick={() => doSearch(searchValue)}
        className="p-2 flex items-center justify-center"
        aria-label="Search"
      >
        <AiOutlineSearch size={24} className="text-gray-500" />
      </button>

      <button
        onClick={() => {}}
        className="p-2 flex items-center justify-center ml-2"
        aria-label="Scan code"
      >
        <AiOutlineQrcode size={24} className="text-gray-500" />
      </button>
    </header>
  );
};

export default HeaderSearch;
